import { motion, useMotionValue, useSpring } from 'framer-motion'
import { Link } from 'react-router-dom'
import { ArrowRight } from 'lucide-react'

function MagneticBtn({ children, to, testId }) {
  const x = useMotionValue(0)
  const y = useMotionValue(0)
  const sx = useSpring(x, { stiffness: 250, damping: 20 })
  const sy = useSpring(y, { stiffness: 250, damping: 20 })

  const onMove = (e) => {
    const r = e.currentTarget.getBoundingClientRect()
    x.set((e.clientX - (r.left + r.width / 2)) * 0.3)
    y.set((e.clientY - (r.top + r.height / 2)) * 0.3)
  }

  return (
    <motion.div
      style={{ x: sx, y: sy, display: 'inline-block' }}
      onMouseMove={onMove}
      onMouseLeave={() => { x.set(0); y.set(0) }}
    >
      <Link
        to={to}
        data-testid={testId}
        className="inline-flex items-center gap-3 bg-white text-[#0A0A0A] text-[10px] font-body font-semibold tracking-[0.18em] uppercase px-8 py-4 rounded-none hover:bg-[#F6F7F9] transition-colors duration-300"
      >
        {children}
      </Link>
    </motion.div>
  )
}

export default function FinalCTA() {
  return (
    <section
      data-testid="final-cta-section"
      className="py-40 md:py-52 px-6 md:px-12 lg:px-24 bg-[#0B1F3A] relative overflow-hidden"
    >
      {/* Decorative grid lines */}
      <div className="absolute inset-0 opacity-5 pointer-events-none">
        <div className="absolute left-1/4 top-0 bottom-0 w-px bg-white" />
        <div className="absolute right-1/4 top-0 bottom-0 w-px bg-white" />
        <div className="absolute top-1/3 left-0 right-0 h-px bg-white" />
        <div className="absolute bottom-1/3 left-0 right-0 h-px bg-white" />
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
        >
          <p className="text-[10px] tracking-[0.38em] uppercase text-white/30 mb-8 font-body font-semibold">
            Let's Build Together
          </p>
          <h2 className="text-[clamp(3rem,8vw,8rem)] font-heading font-black tracking-tighter leading-[0.92] text-white mb-6">
            Ready to make<br />
            <span className="font-light text-white/50">your next search</span><br />
            your best hire?
          </h2>
          <p className="text-base font-body text-white/45 max-w-lg leading-relaxed mb-14">
            Whether you are standing up a GCC, scaling a capability, or placing a single transformational leader — we respond within one business day.
          </p>
          <div className="flex flex-wrap items-center gap-6">
            <MagneticBtn to="/contact" testId="final-cta-primary">
              Start Your Search <ArrowRight size={13} />
            </MagneticBtn>
            <a
              href="mailto:sahil@strivepartners.co"
              data-testid="final-cta-email"
              className="text-[10px] font-body font-semibold tracking-[0.18em] uppercase text-white/50 border-b border-white/20 pb-0.5 hover:text-white hover:border-white transition-colors"
            >
              sahil@strivepartners.co
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  )
}
